mainApp.directive('sidePanelFieldUsage', ['DiscoveryQueryService', function(DiscoveryQueryService) {
    return {
        templateUrl: '/public/components/discovery/side-panel-field-usage.directive.html',
        restrict: 'A',
        link: function(ctrl, el, attrs) {
            ctrl.value = ctrl.$eval(attrs.value);

            ctrl.$watch(attrs.count, val => {
                ctrl.count = val;
                ctrl.percentage = ((ctrl.$eval(attrs.count) / ctrl.$eval(attrs.totalCount)) * 100).toFixed(2);
            })

            ctrl.$watch(attrs.totalCount, val => {
                ctrl.percentage = ((ctrl.$eval(attrs.count) / val) * 100).toFixed(2);
            })

            ctrl.doFormatValue = function(value) {
                return ctrl.$eval(attrs.valueFormatter, {
                    value: value
                });
            }

            ctrl.addValueFilter = function() {
                if (ctrl.value === 'N/A') {
                    ctrl.$eval(attrs.onAddFilter, {
                        value: null,
                        operator: 'not_exists'
                    });
                } else {
                    ctrl.$eval(attrs.onAddFilter, {
                        value: ctrl.value,
                        operator: 'is'
                    });
                }

            }

            ctrl.addValueExclusionFilter = function() {
                if (ctrl.value === 'N/A') {
                    ctrl.$eval(attrs.onAddFilter, {
                        value: null,
                        operator: 'exists'
                    });
                } else {
                    ctrl.$eval(attrs.onAddFilter, {
                        value: ctrl.value,
                        operator: 'is_not'
                    });
                }
            }
        }
    }
}]);